import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

interface CodeBlockProps {
  children: string;
  onCopy: () => void;
  copied: boolean;
  maxHeight?: number;
  copyLabel?: string;
  copiedLabel?: string;
}

export default function CodeBlock({ children, onCopy, copied, maxHeight = 300, copyLabel, copiedLabel }: CodeBlockProps) {
  return (
    <Box
      sx={{
        bgcolor: '#18181b',
        borderRadius: '10px',
        p: 2.5,
        position: 'relative',
        border: '1px solid rgba(255,255,255,0.06)',
        maxHeight,
        overflow: 'auto',
      }}
    >
      <Tooltip title={copied ? (copiedLabel ?? 'Gekopieerd!') : (copyLabel ?? 'Kopieer')}>
        <IconButton
          size="small"
          onClick={onCopy}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: copied ? '#4ade80' : 'rgba(255,255,255,0.4)',
            '&:hover': { color: '#fff' },
          }}
        >
          {copied ? <CheckIcon sx={{ fontSize: 16 }} /> : <ContentCopyIcon sx={{ fontSize: 16 }} />}
        </IconButton>
      </Tooltip>
      <Typography
        component="pre"
        sx={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '0.82rem',
          color: '#e4e4e7',
          m: 0,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          lineHeight: 1.7,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}
